import React, { Component } from 'react';
import Routes from './Routes/Routes';
import ReactGA from 'react-ga';
import { library } from '@fortawesome/fontawesome-svg-core'
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { faIgloo } from '@fortawesome/free-solid-svg-icons'
import './App.css';
import './assets/stylesheets/app.scss';
import config from './config/config';

(function initGoogleAnalytics(){
    const { googleAnalytics } = config;
    if (!googleAnalytics) return;
    ReactGA.initialize(googleAnalytics);
})();

export function reportWebVitals({ id, name, label, value }) {
  const { googleAnalytics } = config;
  if (!googleAnalytics) return;

  ReactGA.send('event', {
    eventCategory: 'Web Vitals',
    eventAction: name,
    eventValue: Math.round(name === 'CLS' ? value * 1000 : value),
    eventLabel: id,
    nonInteraction: true,
  });
}

library.add(faIgloo);

const browserHistory = createBrowserHistory();

const App =() => {
    return (
        <Router history={browserHistory}>
            <Routes />
        </Router>
    )
};
export default App;
